import React, { useState, useEffect } from 'react'
import { Outlet, useOutletContext, useParams, useLocation, useNavigate } from 'react-router-dom'
import { getSession } from '../api/Assinafy';
import Prepare from '../layout/Prepare';
import _ from 'lodash';

const PrepareRouteTemplateUse = ({ virtual }) => {
  const [documentContext, setDocumentContext] = useState({})
  const [signersContext, setSignersContext] = useState([])
  const [fieldsContext, setFieldsContext] = useState([])
  const [signOrderEnabled, setSignOrderEnabled] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()
  const { user } = getSession()
  const { id: documentId } = useParams()
  const stepMatch = location.pathname.match(/.+\/([^/]+)$/)

  useEffect(() => {
    if (!user) {
      navigate('/')
    }
  }, [user, navigate])

  useEffect(() => {
    if (stepMatch[1] !== 'use') {
      if (
        !documentContext.signers &&
        (stepMatch[1] === 'document') 
      ) {
        navigate(`/dashboard/templates/${documentId}/use`);
      }
    }
  }, [virtual, stepMatch, signersContext, fieldsContext, navigate, documentId])

  if (!user) {
    return (<></>)
  }

  return (
    <Prepare> 
      <Outlet context={[
        documentContext, setDocumentContext,
        signersContext, setSignersContext,
        fieldsContext, setFieldsContext,
        signOrderEnabled, setSignOrderEnabled
      ]} />
    </Prepare>
  );
};

export function usePrepareContext() {
  return useOutletContext();
}

export default PrepareRouteTemplateUse;
